// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coupon-input.input{background-color:rgba(31,21,9,.05);background-color:rgba(31,21,9,var(--tw-bg-opacity));height:2.75rem;--tw-bg-opacity:0.05;color:#887e73;font-size:1rem;line-height:1.5rem}.coupon-input.input.error{color:#e53e3e}.coupon-input.input::-moz-placeholder{color:#887e73}.coupon-input.input::placeholder{color:#887e73}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
